import Carrousel from "../Carrousel/Carrousel";

export const Home = () => {
  return (
    <>
      <Carrousel />
    </>
  );
};
